import { navigate } from '@reach/router';
import React, { useState } from 'react';
import { searchPath } from './resourcesHelpers';

type Props = {
  subjectCode: string;
  placeholder: 'Please enter search...' | 'Enter new search...';
};

/**
 * The resource bank search. A blank term is not searched for, and the box empties once a search
 * is made.
 */
const ResourceSearchBox: React.FC<Props> = ({ subjectCode, placeholder }) => {
  const [searchTerm, setSearchTerm] = useState('');

  const submit = (event: React.FormEvent) => {
    event.preventDefault();
    const term = searchTerm.trim();
    if (!term) return;
    setSearchTerm('');
    navigate(searchPath(subjectCode, term));
  };

  return (
    <form className="SearchBox" onSubmit={submit}>
      <input
        className="EditBox SearchInput"
        placeholder={placeholder}
        name="searchString"
        aria-label="Search resources"
        required
        value={searchTerm}
        onChange={(event) => setSearchTerm(event.target.value)}
      />
      <button className="SearchBtn" type="submit">
        Search
      </button>
    </form>
  );
};

export default ResourceSearchBox;
